module.exports = __webpack_public_path__ + "static/media/star-empty-alt.ba3f8747.svg";